var $ = typeof jQuery == 'undefined' ? require('jquery') : jQuery

module.exports = require('./dialog-no-jquery')

